import {Route} from 'entity-manager';

@Route('income_types')
export class IncomeType {

    protected id: string;
    protected code: string;
    protected name: string;
    protected description: string;
    protected isForeign: boolean;
    protected showNotice: boolean;

    public setId(id: string) {
        this.id = id;
        return this;
    }

    public getId(): string {
        return this.id;
    }

    public setCode(code: string) {
        this.code = code;
        return this;
    }

    public getCode(): string {
        return this.code;
    }

    public setName(name: string) {
        this.name = name;
        return this;
    }

    public getName(): string {
        return this.name;
    }

    public setDescription(description: string) {
        this.description = description;
        return this;
    }

    public getDescription() {
        return this.description;
    }

    public setIsForeign(isForeign: boolean) {
        this.isForeign = isForeign;
        return this;
    }

    public getIsForeign(): boolean|undefined {
        return this.isForeign;
    }

    public setShowNotice(showNotice: boolean) {
        this.showNotice = showNotice;
        return this;
    }

    public getShowNotice(): boolean|undefined {
        return this.showNotice;
    }
}
